import {
  Button,
  Card,
  Container,
  Grid,
  Section,
  Stack,
  Typography,
} from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { onMount } from "solid-js";
import { SectionBreadcrumbs } from "../components/SectionBreadcrumbs/SectionBreadcrumbs";
import { useNavbar } from "../contexts/RootContext";

export const Route = createFileRoute("/")({
  staticData: {
    navTitle: "Hjem",
  },
  component: Home,
});

function Home() {
  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  onMount(() => {
    setTitle("Hjem");
  });

  return (
    <Section
      padding="lg"
      breadcrumbs={<SectionBreadcrumbs items={[{ title: "Hjem" }]} />}
    >
      <Container>
        <Stack>
          <Card elevation={200}>
            <Card.Content>
              <Stack>
                <div>
                  <Typography variant="s1" wrap={false}>
                    Format for opplasting av Excel-fil
                  </Typography>
                  <Typography variant="c1" wrap={false}>
                    Filen du laster opp må ha følgende kolonner
                  </Typography>
                </div>
                <Stack>
                  <div>
                    <Typography variant="s2" wrap={false}>
                      Kolonne A – Temaområde
                    </Typography>
                    <Typography variant="b3" wrap={false}>
                      Overordnet område eller fagfelt. Eksempler: Teknisk,
                      Drift, Organisasjon, Sikkerhet, Kvalitet, Opplæring.
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="s2" wrap={false}>
                      Kolonne B – Underkategori
                    </Typography>
                    <Typography variant="b3" wrap={false}>
                      Mer spesifikke emner innenfor hvert temaområde.
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="s2" wrap={false}>
                      Kolonne C – Kravpunkt
                    </Typography>
                    <Typography variant="b3" wrap={false}>
                      Referanser til regelverk, interne retningslinjer eller
                      standarder.
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="s2" wrap={false}>
                      Kolonne D – Prefix
                    </Typography>
                    <Typography variant="b3" wrap={false}>
                      Et kort identifikasjons- eller kodenavn som fungerer som
                      prefiks til kontrollspørsmålet. Kan brukes til referanse,
                      sporing eller gruppering av kontrollpunkter i rapportering
                      og systemer. Eksempel: (a), (b)(1), TEK-05.
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="s2" wrap={false}>
                      Kolonne E – Kontrollspørsmål
                    </Typography>
                    <Typography variant="b3" wrap={false}>
                      Spørsmål som brukes til vurdering eller kontroll av
                      kravpunktet.
                    </Typography>
                  </div>
                </Stack>
              </Stack>
            </Card.Content>
          </Card>
          <Grid columns={4} minColWidth="200px">
            <Card elevation={200}>
              <Card.Content>
                <Card.Title>Maler</Card.Title>
                <Card.Text>Oversikt over alle maler</Card.Text>
              </Card.Content>
              <Card.Actions align="end">
                <Button
                  variant="outline"
                  onClick={() => navigate({ to: "/templates" })}
                >
                  Vis maler
                </Button>
              </Card.Actions>
            </Card>
            <Card elevation={200}>
              <Card.Content>
                <Card.Title>Historie</Card.Title>
                <Card.Text>Tidligere utfylt</Card.Text>
              </Card.Content>
              <Card.Actions align="end">
                <Button
                  variant="outline"
                  onClick={() => navigate({ to: "/history" })}
                >
                  Vis historie
                </Button>
              </Card.Actions>
            </Card>

            <Card elevation={200}>
              <Card.Content>
                <Card.Title></Card.Title>
              </Card.Content>
            </Card>

            <Card elevation={200}>
              <Card.Content>
                <Card.Title>Lagring</Card.Title>
                <Card.Text>Oversikt over bilder og opptak</Card.Text>
              </Card.Content>
              <Card.Actions align="end">
                <Button
                  variant="outline"
                  onClick={() => navigate({ to: "/settings/storage" })}
                >
                  Vis elementer
                </Button>
              </Card.Actions>
            </Card>
          </Grid>

          <a>TEsting</a>
        </Stack>
      </Container>
    </Section>
  );
}
